<input class="form-control" type="text" placeholder="{{(customLabel ? customLabel : ('COMMON_COMMENT' | translate)) + (required ? ' *' : '')}}"
       (ngModelChange)="onCommentChanged($event)"
       [required]="required"
       [ngClass]="{ 'form-control-danger': required && (!commentText || commentText.length === 0) }"
       [ngModel]="commentText" #comment="ngModel" name="comment" [disabled]="disabled">
